import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class InoutManagementService {
  private api = inject(ApiService);

  syncInoutUnits() { return this.api.get('/inout/unit/sync'); }
  getAll() { return this.api.get('/inout/unit'); }
  update(json: any) { return this.api.post('/inout/unit', json); }
}
